const ORDER_STATUS_TRANSITIONS = {
  pending: new Set(['pending', 'preparing', 'completed', 'cancelled', 'deleted']),
  preparing: new Set(['pending', 'preparing', 'completed', 'cancelled', 'deleted']),
  completed: new Set(['completed', 'deleted']),
  cancelled: new Set(['cancelled', 'deleted']),
  deleted: new Set(['deleted']),
};

export const canTransitionOrderStatus = (fromStatus, toStatus) => {
  if (!fromStatus || !toStatus) {
    return false;
  }

  const allowedTransitions = ORDER_STATUS_TRANSITIONS[fromStatus];
  if (!allowedTransitions) {
    return false;
  }

  return allowedTransitions.has(toStatus);
};

export const getOrderTransitionErrorMessage = (fromStatus, toStatus) => {
  if (!fromStatus || !toStatus) {
    return 'Sipariş durumu güncellenemedi.';
  }

  if (fromStatus === 'completed') {
    return 'Tamamlanan sipariş bu aşamaya geri taşınamaz.';
  }

  if (fromStatus === 'cancelled') {
    return 'İptal edilen sipariş yeniden işleme alınamaz.';
  }

  if (fromStatus === 'deleted') {
    return 'Silinen sipariş yeniden taşınamaz.';
  }

  return 'Sipariş seçilen duruma taşınamaz.';
};
